// extracted by mini-css-extract-plugin
module.exports = {"header":"_2KGvgqPIP7yKYhX_uEb5Av","title":"_2NjGuMhRopoBHHC7xHNfrF","subtitle":"TJqkBYNiNbbNUHGz9J58T"};